// Anonymous session token: scopes ownership of seat holds during checkout.
// NOT an auth token. Persisted in localStorage so a refresh keeps the holds.

const KEY = 'okn:session';
const MIN_LEN = 16;

function newToken(): string {
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  // base64url
  return btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function getSessionToken(): string {
  let t = '';
  try {
    t = localStorage.getItem(KEY) ?? '';
  } catch {
    // storage unavailable — fall back to in-memory
  }
  if (t.length < MIN_LEN) {
    t = newToken();
    try {
      localStorage.setItem(KEY, t);
    } catch {
      // ignore
    }
  }
  return t;
}

export function resetSessionToken(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
